import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import BridalElegance from "./sections/BridalElegance";
import EditorialEdge from "./sections/EditorialEdge";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <BridalElegance />
      <EditorialEdge />
      <Footer />
    </div>;
}